import { bl_inv_stock_replenishment_run_filter_item_RowClass } from '../../../dbschema/bl_inv_stock_replenishment_run_filter_item.model';
import { BaseContainerModel } from '../../base-container.model';


export class StockReplenishmentRunFilterItemModel extends BaseContainerModel {
  bl_inv_stock_replenishment_run_item: bl_inv_stock_replenishment_run_filter_item_RowClass = new bl_inv_stock_replenishment_run_filter_item_RowClass();
}
